import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import SsidChartOutlined from "@mui/icons-material/SsidChartOutlined";
import AttachMoneyOutlined from "@mui/icons-material/AttachMoneyOutlined";
import ImportantDevicesOutlined from "@mui/icons-material/ImportantDevicesOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

export type MenuItem = {
  name: string;
  path: string;
  icon: React.ElementType;
  id: string;
};

export type MenuGroups = {
  group1: MenuItem[];
  group2: MenuItem[];
  group3: MenuItem[];
};

export const MENU_ITEMS: MenuGroups = {
  group1: [
    {
      name: "Home",
      path: "/home",
      icon: HomeOutlinedIcon,
      id: "home-menu-btn",
    },
    {
      name: "My Leads",
      path: "/my-leads",
      icon: FilterListOutlinedIcon,
      id: "leads-menu-btn",
    },
    {
      name: "My Clients",
      path: "/my-clients",
      icon: PeopleAltOutlinedIcon,
      id: "clients-menu-btn",
    },
  ],
  group2: [
    {
      name: "Training Portal",
      path: "/training-portal",
      icon: ImportantDevicesOutlined,
      id: "training-menu-btn",
    },
    {
      name: "Back Office",
      path: "/pap",
      icon: AttachMoneyOutlined,
      id: "pap-menu-btn",
    },
    {
      name: "Energy Chart",
      path: "/energy-chart",
      icon: SsidChartOutlined,
      id: "energy-menu-btn",
    },
  ],
  group3: [
    {
      name: "Sign Out",
      path: "/sign-out",
      icon: LogoutOutlinedIcon,
      id: "signout-menu-btn",
    },
  ],
};
